module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n    " + _vm._s(_vm.$route.meta.title) + "\n    "), _c('small', [_vm._v(_vm._s(_vm.$route.meta.description))])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb breadcrumb-below"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  }), _vm._v("Home")])], 1), _vm._v(" "), _vm._l((_vm.breadcrumbs), function(breadcrumb, index) {
    return _c('li', {
      class: _vm.isActive(index)
    }, [_c('router-link', {
      attrs: {
        "to": breadcrumb.path
      }
    }, [_vm._v(_vm._s(breadcrumb.title))])], 1)
  })], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-61caa70f", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61caa70f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/main/ContentHeader.vue
// module id = 2329
// module chunks = 0